import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const brandRBAC = {
  pageID: '44552ced510baa1b2f62ed53a7be3a7a',
  elementID: {
    BtnCreateBrand: '2d3a45d98feeaf3c15bd3f5c4d5fd621',
    BtnUpdateBrand: 'f2979056359cc0b527002a4dd04b6cac',
    BtnUpdateCloudKitchen: '184e78fab3e936a2caa0bdd2c8e3ce10',
  },
} as const

export const useRBACBrandPage = createUseRBAC(brandRBAC.elementID)

export type UseRBACBrandPageType = ReturnType<typeof useRBACBrandPage>
